'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../../styleInject.js');

var css_248z = ".NthFeature-module_footerPadding__X-uO-{padding-top:2rem;width:100%}.NthFeature-module_footerPadding__X-uO->footer>div{padding:1rem 1.5rem}@media screen and (max-width:768px){.NthFeature-module_footerSticky__6sQtM{bottom:0;position:fixed}}";
var styles = {"footerPadding":"NthFeature-module_footerPadding__X-uO-","footerSticky":"NthFeature-module_footerSticky__6sQtM"};
styleInject["default"](css_248z, 'd91bf9c1-6e16-4df7-834c-b78a8fdbe865');

exports["default"] = styles;
